@if (visible()) {
  <div class="pathways-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="whats-new-title">
    <div class="pathways-modal-card whats-new-card">

      <div class="pathways-title-accent-block">
        <div class="modal-brand-row">
          <!-- PAT-123 — compact application logo -->
          <app-pathways-logo variant="icon" />
          <h2 id="whats-new-title" class="pathways-modal-title">What's new in Pathways AI</h2>
        </div>
        <div class="qprime-accent-bar"></div>
      </div>

      @if (notes(); as n) {
        <div class="whats-new-meta">
          <span class="version-badge">v{{ n.version }}</span>
          @if (n.released_at) {
            <span class="release-date">{{ n.released_at | slice:0:10 }}</span>
          }
        </div>
      }
      <div class="whats-new-body" [innerHTML]="previewHtml()"></div>

      <div class="pathways-modal-actions">
        <button
          type="button"
          class="pathways-btn-primary"
          [disabled]="dismissing()"
          (click)="dismiss()"
        >
          @if (dismissing()) {
            <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
            Saving…
          } @else {
            <i class="fa-solid fa-check" aria-hidden="true"></i>
            Got it
          }
        </button>
      </div>

    </div>
  </div>
}
